import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@fontsource/jost/400.css";
import "@fontsource/be-vietnam-pro/400.css";
import "@fontsource/heebo/400.css";
import "@fontsource/almarai/400.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from "./App";
import Locations from "./pages/Locations";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import reportWebVitals from "./reportWebVitals";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Campbell from "./pages/Campbell";
import Shed from "./pages/Shed";
import Storage from "./pages/Storage";
import Attic from "./pages/Attic";
import Deck from "./pages/Deck";
import HoarderCleanouts from "./pages/HoarderCleanouts";
import ForeclosureCleanout from "./pages/ForeclosureCleanout";
import Construction from "./pages/Construction";
import FurnitureTake from "./pages/FurnitureTake";
import Playsets from "./pages/Playsets";
import Pianos from "./pages/Pianos";
import YardWaste from "./pages/YardWaste";
import Scrap from "./pages/Scrap";
import Cardboard from "./pages/Cardboard";
import Carpet from "./pages/Carpet";
import Concrete from "./pages/Concrete";
import ScrollToTop from "./components/ScrollToTop";
import LosAttlos from "./pages/LosAttlos";
import FremontCA from "./pages/FremontCA";
import PaloAltoCA from "./pages/PaloAltoCA";
import SaratogaCA from "./pages/SaratogaCA";
import CupertinoCA from "./pages/CupertinoCA";
import LosGatosCA from "./pages/LosGatosCA";
import MountainViewCA from "./pages/MountainViewCA";
import SanJoseCA from "./pages/SanJoseCA";
import MilpitasCA from "./pages/MilpitasCA";
import NewarkCA from "./pages/NewarkCA";
import SantaClaraCA from "./pages/SantaClaraCA";
import SunnyvaleCA from "./pages/SunnyvaleCA";
import JunkDroidServices from "./pages/JunkDroidServices";
import ApplianceRemoval from "./pages/ApplianceRemoval";
import FenceRemoval from "./pages/FenceRemoval";
import BookOnline from "./pages/BookOnline";
import NotFound from "./pages/NotFound";
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const Geraj = React.lazy(() => import("./pages/Geraj"));
const Cleanout = React.lazy(() => import("./pages/Cleanout"));
const OfficeFurniture = React.lazy(() => import("./pages/OfficeFurniture"));
const HotTubRemoval = React.lazy(() => import("./pages/HotTubRemoval"));
const Apartment = React.lazy(() => import("./pages/Appartment"));
const Electronics = React.lazy(() => import("./pages/Electronics"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Header />
    {/* <React.StrictMode> */}
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Define routes for each page */}
        <Route path="/" element={<App />} />
        <Route path="/services/" element={<JunkDroidServices />} />
        <Route path="/pricing/" element={<Pricing />} />
        <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
        <Route path="/services/estate-cleanout/" element={<Cleanout />} />
        <Route
          path="/services/office-cleanout/"
          element={<OfficeFurniture />}
        />
        <Route path="/services/garage-cleanout/" element={<Geraj />} />
        <Route path="/services/shed-removal/" element={<Shed />} />
        <Route path="/services/storage-unit-cleanouts/" element={<Storage />} />
        <Route path="/services/attic-cleanout/" element={<Attic />} />
        <Route path="/services/apartment-cleanout/" element={<Apartment />} />
        <Route path="/services/deck-demolition/" element={<Deck />} />
        <Route
          path="/services/appliance-removal/"
          element={<ApplianceRemoval />}
        />
        <Route
          path="/services/construction-debris-removal/"
          element={<Construction />}
        />
        <Route
          path="/services/electronic-junk-removal/"
          element={<Electronics />}
        />
        <Route
          path="/services/furniture-removal/"
          element={<FurnitureTake />}
        />
        <Route path="/services/fencing-removal/" element={<FenceRemoval />} />
        <Route
          path="/services/foreclosure-cleanout/"
          element={<ForeclosureCleanout />}
        />
        <Route
          path="/services/hoarder-cleanup/"
          element={<HoarderCleanouts />}
        />
        <Route path="/services/hot-tub-removal/" element={<HotTubRemoval />} />
        <Route path="/services/office-removal/" element={<OfficeFurniture />} />
        <Route path="/services/swing-set-removal/" element={<Playsets />} />
        <Route path="/services/piano-removal/" element={<Pianos />} />
        <Route path="/services/yard-waste-removal/" element={<YardWaste />} />
        <Route path="/services/scrap-metal-removal/" element={<Scrap />} />
        <Route path="/services/cardboard-pickup/" element={<Cardboard />} />
        <Route path="/services/carpet-disposal/" element={<Carpet />} />
        <Route path="/services/concrete-pickup/" element={<Concrete />} />
        <Route path="/contact-us/" element={<Contact />} />
        <Route path="/locations/" element={<Locations />} />
        <Route path="/campbellca/" element={<Campbell />} />
        <Route path="/losaltosca/" element={<LosAttlos />} />
        <Route path="/fremontca/" element={<FremontCA />} />
        <Route path="/paloaltoca/" element={<PaloAltoCA />} />
        <Route path="/saratogaca/" element={<SaratogaCA />} />
        <Route path="/cupertinoca/" element={<CupertinoCA />} />
        <Route path="/losgatosca/" element={<LosGatosCA />} />
        <Route path="/mountainviewca/" element={<MountainViewCA />} />
        <Route path="/sanjoseca/" element={<SanJoseCA />} />
        <Route path="/milpitasca/" element={<MilpitasCA />} />
        <Route path="/newarkca/" element={<NewarkCA />} />
        <Route path="/santaclaraca/" element={<SantaClaraCA />} />
        <Route path="/sunnyvaleca/" element={<SunnyvaleCA />} />
        <Route path="/book-online/" element={<BookOnline />} />
      </Routes>
    </Router>
    {/* </React.StrictMode> */}
    <Footer />
  </>
);
reportWebVitals();
